import { useEffect, useState } from 'react';
import type { IDocumentExchangeRate } from '@insio/shared-types';
import { useInvoiceFetchSuggestedExchangeRate } from '../../../../providers/InvoiceProvider';

/**
 * Fetches the suggested CNB/ECB rate via the InvoiceProvider callback whenever
 * the selected accounting currency changes. Null when the host wires no fetch,
 * no currency is selected, or the currencies match.
 */
export function useSuggestedExchangeRate(
  accountingCurrencyCode: string | null,
  currenciesSame: boolean,
  enabled = true
): IDocumentExchangeRate | null {
  const fetchSuggested = useInvoiceFetchSuggestedExchangeRate();
  const [suggested, setSuggested] = useState<IDocumentExchangeRate | null>(null);

  useEffect(() => {
    if (!enabled || !fetchSuggested || !accountingCurrencyCode || currenciesSame) {
      setSuggested(null);
      return;
    }
    let cancelled = false;
    fetchSuggested(accountingCurrencyCode)
      .then(result => {
        if (!cancelled) setSuggested(result);
      })
      .catch(() => {
        if (!cancelled) setSuggested(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, fetchSuggested, accountingCurrencyCode, currenciesSame]);

  return suggested;
}
